import axios from "axios";
import { getAuthorizationToken } from "../config/user";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function getOtpList(page, limit, searchKey, hospitalId = "", smsDate) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-tms-otps?page=${page}&limit=${limit}&mobileNo=${searchKey}&hospitalId=${hospitalId}&smsDate=${smsDate}`,
    headers: getAuthorizationToken(),
  });
}

function getOtpLogsList(page, limit, searchKey) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/dmapp-logs?page=${page}&limit=${limit}&mobileNo=${searchKey}`,
    headers: getAuthorizationToken(),
  });
}

function getDmappVersionsList(page, limit, searchKey, appType) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/installed-app-version-list?appType=${appType}&page=${page}&limit=${limit}&mobileNo=${encodeURIComponent(
      searchKey
    )}`,
    headers: getAuthorizationToken(),
  });
}

function getUsersCount() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/app-version-count-report`,
    headers: getAuthorizationToken(),
  });
}

function getDmOtpLogsSummary(
  page,
  limit,
  searchKey,
  hospitalId = "",
  smsDate,
  fromDate,
  toDate
) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/dmapp-log-report?page=${page}&limit=${limit}&mobileNo=${searchKey}&hospitalId=${hospitalId}&smsDate=${smsDate}&from=${fromDate}&to=${toDate}`,
    headers: getAuthorizationToken(),
  });
}

export const OtpServices = {
  getOtpList,
  getOtpLogsList,
  getDmappVersionsList,
  getDmOtpLogsSummary,
  getUsersCount,
};
